const username = "uncookd_";

const twitter = {
  username,
  handle: "@" + username,
  card: "summary",
  id: "VXNlcjoxMTAyNTU0Nzc4MDI5MjQ4NTE1",
  rest_id: "1102554778029248515",
};

module.exports = twitter;
